import { actionTypes } from '../actions/google.action';
const initialState = {
    tags: {
        data: []
    },
    tag: {},
    error: {},
    success: false
}

const GoogleReducer = (state = initialState, { type, payload, isLoadMore }) => {
    switch (type) {

    case actionTypes.INDEX:
        if(isLoadMore) {
            payload.tags.data = state.tags.data.concat(payload.tags.data)
        }

        return { ...state, ...payload }

    case actionTypes.UPDATE:
        let index = state.tags.data.findIndex(item => item.id === payload.id)
        state.tags.data[index] = payload

        return {
            ...state,
            tags: {
                ...state.tags,
                data: [
                    ...[(index < 0) && payload],
                    ...state.tags.data
                ]
            }
        }

    case actionTypes.DESTROY:
        return {
            ...state,
            tags: {
                ...state.tags,
                data: state.tags.data.filter(item => item.id !== payload)
            }

        }

    case actionTypes.CHANGE:
        return {
            ...state,
            tag: (payload === 'clear') ? {} : {
                ...state.tag,
                ...payload
            }
        }

    case actionTypes.SUCCESS:
        return {
            ...state,
            success: payload
        }

    case actionTypes.ERROR:
        return {
            ...state,
            error: payload
        }

    default:
        return state
    }
}

export default GoogleReducer